module.exports = __webpack_public_path__ + "static/estate_penthouse-7d6054c449224127875367fb89feb50d.pdf";